// extracted by mini-css-extract-plugin
module.exports = {"tduInfoAndControlContainer":"TduRoot_tduInfoAndControlContainer__eBuNT","tduSchemeContainer":"TduRoot_tduSchemeContainer__WK3G-"};